module.exports = __webpack_public_path__ + "static/media/postponement-album.af958f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/postponement-album.jpg
// module id = 82
// module chunks = 0